import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'

interface IProps {
  name: string
  width?: string
  height?: string
  strokeColor?: string
  strokeWidth?: string
  color?: string
  className?: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'BKSvgIcon',
  props: {
    name: null,
    width: { default: '24px' },
    height: { default: '24px' },
    strokeColor: { default: 'none' },
    strokeWidth: { default: '1px' },
    color: { default: 'var(--color-white)' },
    className: { default: 'svg' }
  },
  setup(__props: any) {

const props = __props as { name: string, width: string, height: string, strokeColor: string, strokeWidth: string, color: string, className: string };

_useCssVars((_vm, _setup) => ({
  "4b799f6e": (_vm.width),
  "5453df04": (_vm.height),
  "4da79c34": (_vm.color),
  "a8b87f64": (_vm.strokeColor),
  "a68a829e": (_vm.strokeWidth)
}))



const iconPath = computed(() => {
  // eslint-disable-next-line
  let icon = require(`/public/img/ui-icons/${props.name}.svg`)
  if (Object.prototype.hasOwnProperty.call(icon, 'default')) {
    icon = icon.default
  }

  return icon.url
})

return { __sfc: true,props, iconPath }
}

})